import { useQuery } from '@tanstack/react-query';

import { getToTalSaved } from '../../../../api/subscription';
import { Saved } from '../../../../type';
import { handleError } from '../../../common';
import { useAlertModal } from '../../hook';

const useTotalSavedQuery = () => {
  const { openAlertModal } = useAlertModal();

  const fallback = {
    partners: 0,
    totalSavedPlastic: 0,
    totalSavedVeg: 0,
  };

  const { data: saved = fallback, ...otherProps } = useQuery({
    queryKey: ['getToTalSaved'],
    queryFn: async () => {
      const { data } = await getToTalSaved();
      return data as Saved;
    },
    meta: {
      onError: (e: unknown) =>
        handleError(openAlertModal, e, '구출한 농산물 가져오기'),
    },
  });

  return { saved, ...otherProps };
};

export default useTotalSavedQuery;
